<template>
<div class="chapter">
<div class="inner_page">
<a id="page_iii"></a>
<h1 class="title">Beating the Nazi Invader</h1>
<p class="subtitle">Hitler’s Spies, Saboteurs and Secrets in Britain 1940</p>
<p class="author">Neil R Storey</p>
<div class="img_containerp">
<img alt="images" src="images/pub.jpg"/>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 03_Title.vue?ae7d967e